<template>
  <header id="lm-header">
    <div class="navbar-custom">
      <transition name="fade" appear>
        <div class="app-search d-none d-xl-block">
          <div class="input-group d-none">
            <input type="text" class="form-control app-search__main-input" :placeholder="$t('Search')">
            <span class="mdi mdi-magnify"></span>
            <div class="input-group-append">
              <button class="btn btn-primary" type="submit">{{ $t('Search')}}</button>
            </div>
          </div>
        </div>
      </transition>
      <button id="button-menu-mobile" class="button-menu-mobile open-left disable-btn d-xl-none" @click="mutationIsOpen">
          <i id="button-menu-mobile-icon" class="mdi mdi-menu"></i>
      </button>
      <b-dropdown id="ddown-header" variant="transparent" no-caret class="m-0 p-0" @click="clearUnreadNotifications">
        <template slot="button-content">
          <div class="account-user-avatar">
            <img :src="avatar" alt="user-image" class="rounded-circle">
          </div>
          <div class="wrapperUserInfo d-none d-xl-block">
            <span class="account-user-name">{{ username }}</span>
            <div v-for="(r, index) in roles" :key="index">
              <span class="account-position">{{ r }}</span>
            </div>
            <span class="account-position">{{ role }}</span>
          </div>
        </template>
        <b-dropdown-header tag="div" class="noti-title">
              <h6 class="text-overflow m-0">{{ $t('hello') }}</h6>
        </b-dropdown-header>
        <b-dropdown-item to="/user-profile">
          <i class="mdi mdi-account-circle"></i>
          <span>{{ $t('my_profile') }}</span>
        </b-dropdown-item>
        <b-dropdown-item :to="el.path" v-for="(el, index) in dropdownMenuItems.data.dropdownMenuItems" :key="index">
          <i class="mdi" :class="el.icon"></i>
          <span>{{el.name}}</span>
        </b-dropdown-item>
        <b-dropdown-item @click="logout()">
          <i class="mdi mdi-logout"></i>
          <span>{{ $t('Logout') }}</span>
        </b-dropdown-item>
      </b-dropdown>
      <b-dropdown id="notification-header" right variant="transparent" no-caret menu-class="shadow" class="m-0 p-0" @show="clearUnreadNotifications" ref="dropdownNotificationHeader">
        <template slot="button-content">
            <i class="dripicons-bell noti-icon" :class="{'text-primary': showingNotifications}"></i>
            <span class="noti-icon-badge" v-if="unreadNotifications"></span>
        </template>
        <b-dropdown-header tag="div" class="noti-title">
          <h5 class="m-0">
             {{$t('news')}}
          </h5>
        </b-dropdown-header>
        <div v-if="!notifications.length">
          <LmSvgIcon
            icon="LmNoNotifyIcon"
            wrapperClass="my-4 d-flex align-items-center flex-column"
            text="No tienes notificaciones"
          />
        </div>
        <b-list-group v-else>
          <b-list-group-item
            v-for="(notification, index) in notifications"
            :key="index"
            :to="notification.click_action"
            :title="notification.title"
            >
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mt-3 mb-1">{{notification.title}}</h5>
               <small class="notification-header-date">{{notificationDate(notification)}}</small>
            </div>
            <p class="mb-1 notification-header-body">
              {{notification.body}}
            </p>
          </b-list-group-item>
          <b-list-group-item
            v-if="isShowedViewMore"
            class="text-center"
            >
            <router-link :to="allNotificationsRoute">{{$t('show_more')}}</router-link>
          </b-list-group-item>
        </b-list-group>
      </b-dropdown>
    </div>
  </header>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import commonsApi from '@/api/commons'
import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')

export default {
  data () {
    return {
      isShowedViewMore: true,
      showingNotifications: false,
      dropdownMenuItems: {
        data: {
          dropdownMenuItems: {}
        }
      }
    }
  },
  props: {
    activeShowMoreAt: {
      type: Number,
      default: 10
    }
  },
  computed: {
    allNotificationsRoute () {
      if (process?.env?.VUE_APP_ENABLE_MICROSERVICES_NOTIFICATIONS === 'yes') {
        return `/${process.env.VUE_APP_LUMBRE_MICROSERVICES_NOTIFICATIONS_PATH}`
      } else {
        return `/${process.env.VUE_APP_LUMBRE_NOTIFICATIONS_PATH}`
      }
    },
    ...mapState('session', ['avatar', 'username', 'role', 'roles']),
    ...mapState('notifications', ['notifications', 'unreadNotifications'])
  },
  methods: {
    notificationDate (notification) {
      if (process?.env?.VUE_APP_ENABLE_MICROSERVICES_NOTIFICATIONS === 'yes') {
        return notification.timeAgoDate
      } else {
        return notification.date
      }
    },
    hideDropDown () {
      this.$refs.dropdownNotificationHeader.hide(true)
    },
    clearUnreadNotifications () {
      this.actionClearUnreadNotifications()
    },
    async logout () {
      try {
        await this.$store.dispatch('session/logout')
        const logoutBC = new BroadcastChannel('logout')
        logoutBC.postMessage(true)
      } catch (error) {
        console.log('error logout header', error)
      }
    },
    ...mapMutations('menu', ['mutationIsOpen']),
    ...mapMutations('notifications', ['mutateUpdateTimeAgo']),
    ...mapActions('notifications', ['actionClearUnreadNotifications']),
    ...mapActions('commons', ['getItems'])
  },
  async mounted () {
    if (process?.env?.VUE_APP_ENABLE_MICROSERVICES_NOTIFICATIONS === 'yes') {
      let updatingTimeAgo
      this.$refs.dropdownNotificationHeader.$on('show', () => {
        this.mutateUpdateTimeAgo()
        this.showingNotifications = true
        updatingTimeAgo = setInterval(() => {
          this.mutateUpdateTimeAgo()
        }, 1000 * 60)
      })
      this.$refs.dropdownNotificationHeader.$on('hidden', () => {
        clearInterval(updatingTimeAgo)
        this.showingNotifications = false
      })
    }
    if (process.env.VUE_APP_DROPDOWN_MIDDLE_MENU === 'yes') {
      this.dropdownMenuItems = await commonsApi.getItems({
        path: `${process.env.VUE_APP_API_SETTINGS_URI}/dropdownmenu/`
      })
    }
  },
  watch: {
    '$route' () {
      this.hideDropDown()
    }
  }
}
</script>

<style lang="sass" scoped>
  #lm-header
    .navbar-custom
      padding: 0 30px
      background-color: #fff
      box-shadow: 0 0 35px 0 rgba(154,161,171,.15)
      min-height: 70px
      @media(max-width: $xl)
        padding: 0 10px
      .button-menu-mobile
        border: none
        color: #313a46
        height: 70px
        line-height: 70px
        width: 60px
        background-color: transparent
        font-size: 24px
        cursor: pointer
        float: left
        &:focus
          outline: none
      #notification-header
        float: right
        position: static
        @media(min-width: $xl)
          position: relative
        .media-body
          max-width: 85%
        .notification-header-body
          font-size: 14px
        .notification-header-date
          font-size: 11px
        .notify-all
          font-size: 14px
          color: $primaryThemeColor
          padding: 10px 20px
          &:hover
            text-decoration: none
            background-color: #f8f9fa
            color: #4250f2
        .noti-icon-badge
          display: inline-block
          position: absolute
          top: 20px
          left: 15px
          right: 5px
          border-radius: 50%
          height: 8px
          width: 8px
          background-color: #fa5c7c
        .noti-icon
          font-size: 22px
          vertical-align: middle
          line-height: 70px
        .dropdown-menu
          width: 100%
          @media(min-width: $md)
            width: 320px
        .noti-title
          background-color: #fff
          padding: 15px 20px
          h5
            font-size: 15px
          small
            font-size: 12px
        .wrapper-dropdown-item
          max-height: 230px
          overflow: auto
          .notify-item
            padding: 10px 20px
            &:hover
              background: red
            .notify-icon
              float: left
              height: 36px
              width: 36px
              line-height: 36px
              text-align: center
              margin-right: 10px
              border-radius: 50%
              color: #fff
              i
                margin: 0
            .notify-details
              margin-bottom: 0
              overflow: hidden
              margin-left: 45px
              text-overflow: ellipsis
              white-space: nowrap
              font-size: 14px
              b
                font-weight: 500
              small
                display: block
                font-size: 12px
      #ddown-header
        color: $mutedFontThemeColor
        min-width: 32px
        display: block
        margin: 0 8px
        text-align: left !important
        position: relative
        background-color: #fafbfd
        border: 1px solid #f1f3fa
        border-width: 0 1px
        min-height: 70px
        float: right
        padding: 5px 20px
        .account-user-avatar
          float: left
          img
            width: 32px
            height: 32px
            max-width: 100%
            max-height: 100%
        .wrapperUserInfo
          text-align: left
          padding-left: 10px
          float: left
          .account-user-name
            font-weight: 600
            color: $mutedFontThemeColor
            font-size: 14px
            display: block
            white-space: initial
          .account-position
            display: block
            font-size: 12px
            margin-top: -3px
            color: $mutedFontThemeColor
            white-space: initial
      .dropdown-menu
        .dropdown-item
          padding: 7px 20px
          display: block
          width: 100%
          clear: both
          font-weight: 400
          color: $primaryFontThemeColor
          text-align: inherit
          white-space: nowrap
          background-color: transparent
          border: 0
          i
            vertical-align: middle
            margin-right: 5px
            font-size: 14px
          span
            font-size: 14px
            vertical-align: middle
      .dropdown-header
        display: block
        padding: .25rem 1.5rem
        margin-bottom: 0
        font-size: .875rem
        color: inherit
        white-space: nowrap
        &.noti-title
          padding: 15px 20px
          h6
            font-size: 12px
      .app-search
        padding: 16px 0
        overflow: hidden
        float: left
        button
          font-size: 14px
        form
          max-width: 320px
          .input-group
            position: relative
            display: flex
            flex-wrap: wrap
            align-items: stretch
            width: 100%
        .app-search__main-input
          border: none
          height: 38px
          padding-left: 40px
          padding-right: 20px
          background-color: #f1f3fa
          box-shadow: none
          &::-webkit-input-placeholder
            color: #c1c1c1
            font-size: 14px
        .mdi-magnify
          position: absolute
          z-index: 10
          font-size: 20px
          line-height: 38px
          left: 10px
        .input-group-append
          margin-left: 0
          z-index: 4
</style>
